import googleAnalyticsAdapter from 'gw-portals-tracking-js/adapters/GoogleAnalyticsAdapter';

var configuration = {
    cookieDomain: 'auto'
};

var plugins = [];

export default {
    configure: function configure(config) {
        Object.assign(configuration, config);
        return this;
    },
    enablePlugin: function enablePlugin(pluginName) {
        plugins.push(pluginName);
        return this;
    },


    $get: ['googleAnalytics', 'CampaignDataService', function (ga, CampaignDataService) {
        return googleAnalyticsAdapter(ga, configuration, plugins, CampaignDataService);
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-angular/adapters/googleAnalyticsAdapterProvider.js
// module id = 911
// module chunks = 0